export default __webpack_public_path__ + "static/media/ablegen.26bdbbff.mp3";